var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',_vm._g(_vm._b({attrs:{"title":_vm.dialogTitle,"description":_vm.dialogDescription,"config":_vm.configDefault},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'Dialog',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }